import { icon_fold_on } from 'components/base/images';
import React, { useState, useRef } from 'react';
import { useController, Control } from 'react-hook-form';
import styled from 'styled-components';
import cx from 'classnames';
import CustomText from '../text/CustomText';
import useOutsideClick from 'lib/hooks/useOutsideClick';
import { TValue } from 'lib/types/common';

interface DropdownOptionProps {
  value: TValue;
  options: { value: TValue; label: string }[]; // 드롭다운 옵션을 받는 props
  disabled?: boolean;
  height?: number;
  fontSize?: number;
  onChange?: (value: TValue) => void;
}

function DropdownOption({
  value,
  options,
  disabled = false,
  height = 50,
  fontSize = 20,
  onChange,
}: DropdownOptionProps) {
  const [isListOpen, setIsListOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleList = () => {
    setIsListOpen(!isListOpen);
  };

  const handleOptionClick = (value: TValue) => {
    !!onChange && onChange(value);
    setIsListOpen(false);
  };

  useOutsideClick({
    ref: dropdownRef,
    handler: () => setIsListOpen(false),
  });

  return (
    <StyledDropdownOption $height={height} ref={dropdownRef}>
      <button
        type="button"
        className="dropdownOption__button"
        disabled={disabled}
        onClick={toggleList}
      >
        <CustomText fontSize={fontSize} fontWeight={400} color="#222">
          {options.find(option => option.value === value)?.label || ''}
        </CustomText>

        <img
          src={icon_fold_on}
          className={cx('icon_arrow', {
            open: isListOpen,
            closed: !isListOpen,
          })}
        />
      </button>

      {isListOpen && (
        <ul className="dropdownOption__listbox">
          {options.map(option => (
            <li
              key={Number(option.value)}
              className="list_option"
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </StyledDropdownOption>
  );
}

const StyledDropdownOption = styled.div<{ $height: number }>`
  position: relative;
  width: 100%;
  .dropdownOption__button {
    width: 100%;
    /* height: 50px; */
    height: ${({ $height }) => !!$height && $height}px;
    border-radius: 2px;
    border: 1px solid #e1e1e7;
    padding: 12px;
    text-align: left;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .icon {
      transition: transform 0.2s ease;
    }

    .open {
      transform: rotate(180deg);
    }

    &:disabled {
      background: #f9f9fb;
      color: #888;
    }
  }

  .dropdownOption__listbox {
    z-index: 9999;
    position: absolute;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.16);
    border-radius: 3px 3px 0px 0px;
    /* margin-top: 4px; */
    list-style: none;
    padding: 0;
    max-height: 200px;
    overflow-y: auto;

    .list_option {
      padding: 14px;
      cursor: pointer;
      &:hover {
        background-color: #eef9fd;
      }
    }
  }

  span {
    color: red;
    font-size: 12px;
  }
`;

export default DropdownOption;
